<template>
    <div class="battery-element" :style="batteryStyle">
        <span>#{{ props.batteryId }}</span>
        <span>{{ batteryIssue }}</span>
    </div>
</template>

<script setup>

    import { computed } from 'vue';
    import '../assets/scss/desktop/components/_battery.scss'

    const props = defineProps({
        batteryId: {
            required: true,
            type: Number
        },
        batteryTemp: {
            required: true,
             type: Number
        },
        batteryVoltage: {
            required: true,
            type: Number
        }
    })

    const batteryIssue = computed(() => {
        let text = "";
        if(props.batteryTemp < 5 || props.batteryTemp > 55){
            text += "T"
        } 

        if(props.batteryVoltage < 2.7) {
            text+= (text==="" ? "V" : ", V")
        }

        return text;
    })

    const batteryStyle = computed(() => {
    if(props.batteryTemp <= 0 && props.batteryVoltage <= 0){
        return {backgroundColor: '#706F6F'};
    }
    if ((props.batteryTemp <= 0 || props.batteryTemp >= 60) && props.batteryVoltage <= 0) {
        return {
            backgroundColor: '#BB1E10 !important'
        };
    } else if ((props.batteryTemp < 5 || props.batteryTemp > 55) && props.batteryVoltage < 2.7) {
        return {
            backgroundColor: 'orange !important'
        };
    } else {
        return {
            backgroundColor: 'green !important'
        };
    }
});


</script>